import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
// import Nav from '../components/nav.vue'


export default new VueRouter({
    linkActiveClass:'active',
    routes:[
        {
            path:'/',
            component: ()=> import('../pages/home.vue')
        },
        {
            path:'/about',
            component: ()=> import('../components/layout.vue'),
            redirect: '/about/introduction',
            children:[
                {
                    path:'introduction',
                    component: ()=> import('../pages/about/index.vue')
                },
                {
                    path:'honour',
                    component: ()=> import('../pages/about/honour.vue')
                },
                {
                    path:'leader',
                    component: ()=> import('../pages/about/leader.vue')
                },
                {
                    path:'media',
                    component: ()=> import('../pages/about/media.vue')
                }
            ]
        },
        {
            path:'/culture/:id',
            component: ()=> import('../components/culture.vue')
        },
        {
            path:'/culture/:id/:detail',
            component: ()=> import('../pages/detail.vue')
        },
        {
            path:'/party/:id/:detail',
            component: ()=> import('../pages/ndetail.vue')
        },
        {
            path:'/about/:id/:detail',
            component: ()=> import('../pages/about/detail.vue')
        },
        {
            path:'/character',
            component: ()=> import('../pages/character.vue')
        },
        {
            path:'/character/dtail/:id',
            component: ()=> import('../pages/cdetail.vue')
        },
        {
            path:'/service',
            component: ()=> import('../pages/service.vue')
        },
        {
            path:'/service/:id',
            component: ()=> import('../pages/sdetail.vue')
        },
        {
            path:'/security',
            component: ()=> import('../pages/security.vue')
        },
        {
            path:'/party',
            component: ()=> import('../components/party.vue'),
            redirect: '/party/member',
            children:[
                {
                    path:'member',
                    component: ()=> import('../pages/party/member.vue')
                },
                {
                    path:'grid',
                    component: ()=> import('../pages/party/grid.vue')
                },
                {
                    path: 'activity',
                    component: ()=> import('../pages/party/activity.vue')
                },
                {
                    path: 'platform',
                    component: ()=> import('../pages/party/platform.vue')
                }
            ]
        },
        {
            path:'/family/:pId?',
            component: ()=> import('../components/family.vue')
        }
    ]
})